import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import FormModal from "./modifyModal";
import { callAPI } from "../../utils";
const generateYears = ({ start = 1900 } = {}) => {
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= start; i--) {
    years.push({ value: i, label: i.toString() });
  }
  return years;
};



const mapStudentDataToFormData = (studentData) => {
  const transformToArray = (data) => {
    if (Array.isArray(data)) {
      return data
        .filter(item => item.value !== null)
        .map(item => item|| null);
    }
    
    if (data && data.value !== null) {
      return [data || null];
    }
    
    return [];
  };

  console.log(studentData)

  return {
    personalInfo: {
      name: { value: studentData.name?.value || null },
      email: { value: studentData.email?.value || null },
      phoneNumber: { value: studentData.phoneNumber?.value || null },
      address: { value: studentData.address?.value || null },
      gender: { value: studentData.gender[0]?.value || null },
      id: { value: studentData.id?.value || null }
    },
    students: {
      parentName: { value: studentData.parentName?.value || null },
      methodOfDelivery: { value: studentData.methodOfDelivery[0]?.value || null },
      frequency: { value: studentData.frequency[0]?.value || null },
      school: { value: studentData.school[0]?.value || null },
      yearLevel: { value: studentData.yearLevel[0]?.value || null },
      availability: { value: studentData.availability?.value || null },
      cancellations: { value: studentData.cancellations[0]?.value || null },
      financeNotes: { value: studentData.financeNotes?.value || null },
      frequencyNotes: { value: studentData.frequencyNotes?.value || null },
      callNotes: { value: studentData.callNotes?.value || null },
    },
    statussystem: {
      status: { value: studentData.status[0]?.value || null },
      statusInfo: { value: studentData.statusInfo?.value || null },
      statusCheckin: { value: studentData.statusCheckin?.value || null },
    },
    junctions: {
      tutorRequirements: transformToArray(studentData.tutorRequirements),
      learningDifficulty: transformToArray(studentData.learningDifficulty),
      subjects: transformToArray(studentData.subjects),
    },
  };
};

const ManageTutorModal = ({ data, callbacks, mode }) => {
  const [staticTables, setStaticTables] = useState([]);
  const [initialFormData, setInitialFormData] = useState([]);
  const [formValues, setFormValues] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getStaticTables = async () => {
      const response = await callAPI({
        request: "database/getStaticTables",
        method: "post",
        params: { tables: fieldsConfig.staticTables || [] },
        onSuccess: (response) => {
          setStaticTables(response.data);
        },
        onError: (errorMessage) => {
          console.error("Failed to fetch static tables:", errorMessage);
        },
      });

      return response.data
    };

    const getStudent = async () => {
      if (mode === "create") return

      await callAPI({
        request: "database/admin/getEntities",
        method: "post",
        params: { entityType: "students", entityID: data.id },
        onSuccess: (response) => {
          const data = mapStudentDataToFormData(response.data.data[0])

          setFormValues(data)
          setInitialFormData(data)
        },
        onError: (errorMessage) => {
          console.error("Failed to fetch students:", errorMessage);
        },
      })
    }

    getStudent()
    getStaticTables()
  }, [data?.id, mode]);
 

  const fieldsConfig = {
    mapData: mapStudentDataToFormData,
    staticTables: [
     "gender", "methodofdelivery", "frequency", "schools", "yearlevel", "cancellations", "statuses",
     "tutorrequirementstags", "learningdifficulty", "subjects"
    ],
    sections: [
      {
        section: "Personal Information",
        fields: [
          { label: "Name", id: "personalInfo.name", type: "text", required: true },
          { label: "Parents Name", id: "students.parentName", type: "text", required: true },

          { label: "Gender", id: "personalInfo.gender", type: "select", required: true, options: staticTables?.gender || [] },
          { label: "Email", id: "personalInfo.email", type: "email", required: true },
          { label: "Phone Number", id: "personalInfo.phoneNumber", type: "tel", required: true },
          { label: "Address", id: "personalInfo.address", type: "text", required: true  },

        ]
      },
      { section: "Tutoring Information",
        fields: [
          { label: "Method of Delivery", id: "students.methodOfDelivery", type: "select", options: staticTables?.methodofdelivery || [], required: true },

          { label: "School", id: "students.school", type: "select", options: staticTables?.school || [], required: true },
          { label: "Year Level", id: "students.yearLevel", type: "select", options: staticTables?.yearlevel || [], required: true },

          { label: "Subjects", id: "junctions.subjects", type: "multi-select", options: staticTables?.subjects || [], required: true },


          { label: "Frequency", id: "students.frequency", type: "select", options: staticTables?.frequency || [], required: true },
          { label: "Frequency Notes", id: "students.frequencyNotes", type: "textarea", required: true },
          { label: "Availability", id: "students.availability", type: "textarea", required: true },

          { label: "Tutor Requirements", id: "junctions.tutorRequirements", type: "multi-select", options: staticTables?.tutorrequirements || [] },
          { label: "Learning Difficulties", id: "junctions.learningDifficulty", type: "multi-select", options: staticTables?.learningdifficulty || []},

          { label: "Cancellations", id: "students.cancellations", type: "select", options: staticTables?.cancellations || [], disabled: true },

          { label: "Finance Notes", id: "students.financeNotes", type: "textarea" },
          { label: "Call Notes", id: "students.callNotes", type: "textarea", required: true },
        ]
      },
      {
        section: "Status Information",
        fields: [
          { label: "Status", id: "statussystem.status", type: "select", options: staticTables?.status || [], required: true },
          { label: "Status Information", id: "statussystem.statusInfo", type: "textarea" },
          { label: "Status Check-in Date", id: "statussystem.statusCheckin", type: "date" },
        ]
      },
      {
        section: "Manage Student",
        fields: [
          mode === "editWithName" && {
            title: "Manage tutor relations",
            label: "Manage relations", 
            id: "manageStudent.tutorRelations", 
            type: "button", 
            onChange: () => navigate("/assignTutors", { state: { student: formValues, subjects: staticTables?.subjects || [] }})
          },
        ]
      },
    ],
    requiredFields: [],
  };

  const submitAPI = "students/modifyStudent";
  const deleteAPI = `students/deleteStudent/${data.id}`;

  const onSubmitSuccess = (updatedData, mode) => {
    callbacks.updateRow(updatedData, "studentId", mode === "editWithName" ? "modify" : "create");
    callbacks.onClose();
    window.location.reload();
  };

  const onClose = () => {
    callbacks.onClose();
  };

  return (
    <FormModal
      fieldsConfig={fieldsConfig}
      data={data}
      mode={mode}
      changes = {"changedFields"}
      type={"sidePeak"}
      title={mode === "editWithName" ? "Editing student: " + formValues?.["personalInfo"]?.["name"]?.value : "Creating student"}
      submitAPI={submitAPI}
      deleteAPI={deleteAPI}
      onSubmitSuccess={onSubmitSuccess}
      onClose={onClose}
      formData={formValues}
      initialFormData = {initialFormData}
      setFormData={setFormValues}
    />
  );
};

export default ManageTutorModal;
